export default {"src":"/_next/static/media/chevronDownUiLight_24.248a3c4a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};